import { useQuery } from '@tanstack/react-query';
import { queryKeys, appsService } from '@v2/services';
import type { App } from '@v2/types';

interface UseAppsResult {
  apps: App[];
  loading: boolean;
  error: string | null;
}

export const useApps = (): UseAppsResult => {
  const query = useQuery({
    queryKey: queryKeys.apps.lists(),
    queryFn: appsService.getApps,
  });

  return {
    apps: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
  };
};

export default useApps;
